import React, { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { createPartner, getPartner, updatePartner } from "../../actions/ActionPartnerWL";
// import PageClean from "../default/PageClean";
import Alert from "../../components/Alert";
import { Input } from "reactstrap";
import MaskedInput from "react-text-mask";
import Select, { createFilter } from 'react-select';
import { aCountryOptions, aStateOptions, getBrazilCities, getPostalCodeAddress } from "../customer/CustomerForm";
import { validateCNPJ } from "../../config/Validator";
import AltCheckbox from "../../components/AltCheckbox";
import imgfLoading from '../../assets/img/preloader-black.gif';
import LogoList from "./LogoList";

const aMaskCnpj = [/\d/,/\d/,'.',/\d/,/\d/,/\d/,'.',/\d/,/\d/,/\d/,'/',/\d/,/\d/,/\d/,/\d/,'-',/\d/,/\d/];
const aMaskPhone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const aMaskPostalCode = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
const aSmtpEncryptionOptions = [
  { label: "SSL", value: "ssl" },
  { label: "TLS", value: "tls" },
];
const oEmptyPartner = {
  wlpn_cname: '',
  wlpn_cfantasyname: '',
  wlpn_ccnpj: '',
  wlpn_cemail: '',
  wlpn_cphone: '',
  wlpn_ccellphone: '',

  wlpn_cIE: '',
  wlpn_cIM: '',
  wlpn_etaxframework: 'Não optante',

  wlpn_cpostalcode: '',
  wlpn_cstreet: '',
  wlpn_cnumber: '',
  wlpn_ccomplement: '',
  wlpn_cdistrict: '',
  wlpn_ccity: '',
  wlpn_cstate: '',
  wlpn_ccountry: 'Brasil',
  wlpn_cibgecode: '',

  wlpn_cdomain: '',
  wlpn_cturnstilekey: '',
  wlpn_cturnstilesecret: '',
  wlpn_ctitle: '',

  wlpn_csmtp: '',
  wlpn_csmtpuser: '',
  wlpn_csmtppassword: '',
  wlpn_nsmtpport: 0,
  wlpn_csmtpencryption: 'ssl',
};
const oInvalidFieldMessages = {
  wlpn_ccnpj: 'CNPJ inválido!',
  wlpn_cpostalcode: 'CEP inválido!',
}

// 21.755.084/0001-43
// 76810-135

const PartnerForm = ({
  history,
  match,
  location,
  ...props
}) => {
  const nWlpnId = useMemo(() => {
    const nId = match.params.nWlpnId;
    return nId ? +nId : null;
  }, [match]);

  const oLogoListRef = useRef(null);

  const [oPartner, setPartner] = useState(oEmptyPartner);
  const [oInvalidFields, setInvalidFields] = useState({});

  const [bPostalcodeValidated, setPostalCodeValidated] = useState(false);

  const [aCityOptions, setCityOptions] = useState([]);
  const [bIsLoading, setLoading] = useState(true);
  const [bIsSubmitting, setIsSubmitting] = useState(false);

  const bIsBrazilAddress = useMemo(() => oPartner.wlpn_ccountry === 'Brasil', [oPartner]);

  useEffect(() => {
    loadPartner();
  }, [nWlpnId]);

  useLayoutEffect(() => {
    if (!bIsLoading && nWlpnId && location.search.includes('set-logos=true')) {
      setTimeout(() => {scrollToRef(oLogoListRef)}, 300);
    }
  }, [location, bIsLoading]);

  const loadPartner = useCallback(async () => {
    if (!nWlpnId) {
      setLoading(false);
      return;
    }
    try {
      const oResult = await getPartner(nWlpnId);
      setPartner(oResult);
      setPostalCodeValidated(true);
      updateCityOptions(oResult.wlpn_cstate);
    } catch (oError) {
      console.log(oError);
    }
    setLoading(false);
  }, [nWlpnId]);

  const handleSubmit = useCallback(async (evtSubmit) => {
    evtSubmit.preventDefault();

    if ([
      bIsSubmitting,
      Object.keys(oInvalidFields).length !== 0,
      !bPostalcodeValidated,
      !validateFormCnpj(oPartner.wlpn_ccnpj),
    ].some((bVal) => bVal)) {
      return;
    }

    if (nWlpnId) {
      const aOptional = ['wlpn_csmtppassword', 'wlpn_cturnstilesecret'];
      for (const cKey of aOptional) {
        if (!oPartner[cKey]) {
          delete oPartner[cKey];
        }
      }
    }

    setIsSubmitting(true);
    try {
      if (nWlpnId) {
        await updatePartner(nWlpnId, oPartner);
        props.setAlert('success', 'Parceiro atualizado com sucesso');
        history.push({ pathname: '/Partner/Update/' + nWlpnId, search: '' });
      } else {
        const oResult = await createPartner(oPartner);
        props.setAlert('success', 'Parceiro cadastrado com sucesso');
        history.push({
          pathname: '/Partner/Update/' + oResult.nWlpnId,
          search: "?set-logos=true"
        });
      }
    } catch (oError) {
      console.log('error on submit', oError);
    } finally {
      setIsSubmitting(false);
    }
  }, [oPartner, nWlpnId, bIsSubmitting, bPostalcodeValidated, oInvalidFields, location]);

  const setInvalidField = useCallback((cField) => {
    setInvalidFields((oPrv) => ({ ...oPrv, [cField]: oInvalidFieldMessages[cField] }));
  }, []);

  const clearInvalidField = useCallback((cField) => {
    setInvalidFields((oPrv) => {
      const oNew = { ...oPrv };
      delete oNew[cField];
      return oNew;
    });
  }, []);

  const validatePostalCode = useCallback(async (cValue, bSkip = bPostalcodeValidated) => {
    const cPostalCode = cValue.replace(/\D/g, '');

    if (bIsSubmitting || bSkip) return;
    setPostalCodeValidated(false);
    setIsSubmitting(true);

    try {
      if (!cPostalCode) {
        throw new Error();
      }
      const oResult = await getPostalCodeAddress(cPostalCode, 'wlpn_');
      oResult.wlpn_cnumber = '';

      setPartner((oPrv) => ({ ...oPrv, ...oResult }));
      clearInvalidField('wlpn_cpostalcode');
      setPostalCodeValidated(true);
    } catch (oError) {
      setInvalidField('wlpn_cpostalcode');
    }
    setIsSubmitting(false);
  }, [bIsSubmitting, bPostalcodeValidated]);

  const validateFormCnpj = useCallback((cCnpj) => {
    const cValue = cCnpj.replace(/\D/g, '');
    const bIsValid = validateCNPJ(cValue);
    if (!bIsValid) {
      setInvalidField('wlpn_ccnpj');
    } else {
      clearInvalidField('wlpn_ccnpj');
    }
    return bIsValid;
  }, []);

  const handlePartnerChange = async (evtChange) => {
    const cField = evtChange.target.name;
    const cValue = evtChange.target.value;

    const oPartnerNew = {
      [cField]: cValue,
    }
    /* eslint-disable default-case, no-fallthrough */
    switch (cField) {
      case 'wlpn_ccountry':
        oPartnerNew.wlpn_cstate = '';
      case 'wlpn_cstate':
        oPartnerNew.wlpn_ccity = '';
      case 'wlpn_ccity':
        const { ibge } = aCityOptions.find(oCity => oCity.value === oPartnerNew.wlpn_ccity) || { ibge: null };
        oPartnerNew.wlpn_cibgecode = ibge;
    }
    /* eslint-enable default-case, no-fallthrough */

    setPartner((oPrv) => ({
      ...oPrv,
      ...oPartnerNew
    }));

    if (oPartnerNew.wlpn_cstate !== oPartner.wlpn_cstate) {
      updateCityOptions(oPartnerNew.wlpn_cstate);
    }
  };

  const updateCityOptions = useCallback(async (cUF) => {
    try {
      const aOptions = bIsBrazilAddress && cUF ? await getBrazilCities(cUF) : [];
      setCityOptions(aOptions);
    } catch (oError) {
      setCityOptions([]);
    }
  }, [bIsBrazilAddress]);

  const scrollToRef = (oRef) => {
    if (!oRef || !oRef.current) return;
    oRef.current.scrollIntoView({ behavior: 'smooth' });
  }

  if (bIsLoading) {
    return (
      <div className="centered-text">
        <img alt='Carregando' src={imgfLoading} /> Carregando...
      </div>
    );
  }

  return (
    <>


      <form autoComplete="false" onSubmit={handleSubmit} className="form">
        {Object.entries(oInvalidFields).map(([cField, cMsg]) => (
          <Alert
            key={cField}
            type="error"
            onCloseAlert={() => clearInvalidField(cField)}
            isOpen
          >
            {cMsg}
          </Alert>
        ))}

        <fieldset>
          <legend>Informações cadastrais</legend>

          <label className="split2">
            Razão Social <span className="required">*</span>
            <Input
              type="text"
              name="wlpn_cname"
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cname || ''}
              required
              maxLength="250"
            />
          </label>

          <label className="split2">
            Nome fantasia <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cfantasyname || ''}
              type="text"
              name="wlpn_cfantasyname"
              placeholder="Nome fantasia"
              required
              maxLength="250"
            />
          </label>


          <label className="split3">
            CNPJ <span className="required">*</span>
            <MaskedInput
              mask={aMaskCnpj}
              onBlur={(evtBlur) => {
                const cValue = evtBlur.target.value;
                if (cValue) {
                  validateFormCnpj(cValue);
                }
              }}
              onChange={(evtChange) => {
                const cValue = evtChange.target.value.replace(/\D/g, '');
                handlePartnerChange(evtChange);
                if (cValue.length === 14) {
                  validateFormCnpj(cValue)
                }
              }}
              render={(cRef, oProps) => (
                <Input
                  innerRef={cRef}
                  {...oProps}
                  value={oPartner.wlpn_ccnpj || ''}
                  type="text"
                  name="wlpn_ccnpj"
                  placeholder="CNPJ"
                  required
                />
              )}
            />
          </label>

          <label className="split3 colspan">
            E-mail financeiro <span className="required">*</span>
            <Input
              type="email"
              name="wlpn_cemail"
              value={oPartner.wlpn_cemail || ''}
              onChange={handlePartnerChange}
              required
            />
          </label>


          <label className="split2">
            Telefone
            <MaskedInput
              mask={aMaskPhone}
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              render={(cRef, oProps) => (
                <Input
                  innerRef={cRef}
                  {...oProps}
                  value={oPartner.wlpn_cphone || ''}
                  type="text"
                  name="wlpn_cphone"
                  className="mask-phone"
                  placeholder="Telefone"
                />
              )}
            />
          </label>

          <label className="split2">
            Celular <span className="required">*</span>
            <MaskedInput
              mask={aMaskPhone}
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              render={(cRef, oProps) => (
                <Input
                  innerRef={cRef}
                  {...oProps}
                  value={oPartner.wlpn_ccellphone || ''}
                  type="text"
                  name="wlpn_ccellphone"
                  className="mask-phone"
                  placeholder="Celular"
                  required
                />
              )}
            />
          </label>


          <label className="split2">
            Inscrição Estadual <span className="required">*</span>
            <Input
              type="text"
              name="wlpn_cIE"
              value={oPartner.wlpn_cIE || ''}
              onChange={handlePartnerChange}
              required
            />
          </label>

          <label className="split2">
            Inscrição Municipal
            <Input
              type="text"
              name="wlpn_cIM"
              value={oPartner.wlpn_cIM || ''}
              onChange={handlePartnerChange}
            />
          </label>


          <AltCheckbox
            checked={oPartner.wlpn_etaxframework === 'Isento'}
            onChange={(evtChange) => {
              const bChecked = evtChange.target.checked;
              setPartner((oPrv) => ({
                ...oPrv,
                wlpn_etaxframework: bChecked ? 'Isento' : 'Não optante'
              }));
            }}
            label="Entidade pública"
            style={{paddingTop: '10px'}}
          />

          <AltCheckbox
            checked={oPartner.wlpn_etaxframework === 'Optante'}
            onChange={(evtChange) => {
              const bChecked = evtChange.target.checked;
              setPartner((oPrv) => ({
                ...oPrv,
                wlpn_etaxframework: bChecked ? 'Optante' : 'Não optante'
              }));
            }}
            label="Optante pelo Simples"
            style={{paddingTop: '10px'}}
          />
        </fieldset>


        <fieldset>
          <legend>Endereço</legend>

          <label className="split2 search">
            CEP <span className="required">*</span>
            <MaskedInput
              mask={aMaskPostalCode}
              onChange={(evtChange) => {
                const cValue = evtChange.target.value;
                if (cValue !== oPartner.wlpn_cpostalcode && /[0-9]$/.test(cValue)) {
                  validatePostalCode(cValue, false);
                }
                handlePartnerChange(evtChange);
              }}
              onBlur={(evtBlur) => {
                const cValue = evtBlur.target.value;
                if (cValue) {
                  validatePostalCode(cValue);
                }
              }}
              render={(cRef, oProps) => (
                <Input
                  innerRef={cRef}
                  {...oProps}
                  value={oPartner.wlpn_cpostalcode || ''}
                  type="text"
                  className="mask-cep cep-fill"
                  name="wlpn_cpostalcode"
                  placeholder="CEP"
                  required
                />
              )}
            />
            <span
              onClick={() => validatePostalCode(oPartner.wlpn_cpostalcode)}
              title="Buscar Cep"
              className="btn-hover"
            />
          </label>

          <label className="split2">
            País <span className="required">*</span>
            <Select
              className="selectCustom"
              classNamePrefix="react-select"
              options={aCountryOptions}
              onChange={(oOption) => handlePartnerChange({
                target: { name: 'wlpn_ccountry', value: oOption.value }
              })}
              value={{ label: oPartner.wlpn_ccountry || '', value: oPartner.wlpn_ccountry || '' }}
              placeholder="País"
              required
            />
          </label>

          <label className="split2">
            Estado <span className="required">*</span>
            {bIsBrazilAddress ? (
              <Select
                className="selectCustom"
                classNamePrefix="react-select"
                options={aStateOptions}
                onChange={(oOption) => handlePartnerChange({ target:
                  { name: 'wlpn_cstate', value: oOption.value }
                })}
                value={{ label: oPartner.wlpn_cstate || '', value: oPartner.wlpn_cstate || '' }}
                placeholder="UF"
                required
              />
            ) : (
              <Input
                onChange={handlePartnerChange}
                value={oPartner.wlpn_cstate || ''}
                type="text"
                name="wlpn_cstate"
                id="wlpn_cstate"
                placeholder="Estado"
              />
            )}
          </label>

          <label className="split2">
            Cidade <span className="required">*</span>
            {bIsBrazilAddress ? (
              <Select
                className="selectCustom"
                classNamePrefix="react-select"
                filterOption={createFilter({ matchFrom: 'start' })}
                options={aCityOptions}
                onChange={(oOption) => handlePartnerChange({ target:
                  { name: 'wlpn_ccity', value: oOption.value }
                })}
                value={{ label: oPartner.wlpn_ccity || '', value: oPartner.wlpn_ccity || '' }}
                placeholder="Cidade"
                required
              />
            ) : (
              <Input
                onChange={handlePartnerChange}
                value={oPartner.wlpn_ccity || ''}
                type="text"
                name="wlpn_ccity"
                placeholder="Cidade"
              />
            )}
          </label>

          <label className="split2">
            Bairro <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cdistrict || ''}
              type="text"
              name="wlpn_cdistrict"
              placeholder="Bairro"
            />
          </label>

          <label className="split2">
            Endereço <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cstreet || ''}
              type="text"
              name="wlpn_cstreet"
              placeholder="Endereço"
            />
          </label>

          <label className="split2">
            Número <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cnumber || ''}
              type="text"
              name="wlpn_cnumber"
            />
          </label>

          <label className="split2">
            Complemento
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_ccomplement || ''}
              type="text"
              name="wlpn_ccomplement"
            />
          </label>

        </fieldset>

        <fieldset>
          <legend>Dados de domínio</legend>

          <label className="split2">
            URL pública <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cdomain || ''}
              type="text"
              name="wlpn_cdomain"
              placeholder="app.exemplo.com"
              required
            />
          </label>
          <label className="split2">
            Título do sistema <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_ctitle || ''}
              type="text"
              name="wlpn_ctitle"
              required
            />
          </label>

          <label className="split2">
            Chave do Cloudflare turnstile <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cturnstilekey || ''}
              type="text"
              name="wlpn_cturnstilekey"
              required
            />
          </label>
          <label className="split2">
            Segredo do Cloudflare turnstile {!nWlpnId && <span className="required">*</span>}
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_cturnstilesecret || ''}
              type="password"
              name="wlpn_cturnstilesecret"
              required={!nWlpnId}
            />
          </label>
        </fieldset>


        <fieldset>
          <legend>Dados SMTP</legend>

          <label className="split">
            Servidor SMTP <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_csmtp || ''}
              type="text"
              name="wlpn_csmtp"
              placeholder="smtp.gmail.com"
              required
            />
          </label>

          <label className="split2">
            Porta SMTP <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_nsmtpport || ''}
              type="text"
              name="wlpn_nsmtpport"
              required
            />
          </label>
          <label className="split2">
            Criptografia <span className="required">*</span>
            <Select
              className="selectCustom"
              classNamePrefix="react-select"
              options={aSmtpEncryptionOptions}
              onChange={(oOption) => handlePartnerChange({
                target: { name: 'wlpn_csmtpencryption', value: oOption.value }
              })}
              value={aSmtpEncryptionOptions.find(oOption => oOption.value === oPartner.wlpn_csmtpencryption) || {value: '', label: ''}}
              required
            />
          </label>

          <label className="split2">
            Email SMTP para o serviço de emails <span className="required">*</span>
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_csmtpuser || ''}
              type="email"
              name="wlpn_csmtpuser"
              placeholder="naoresponda@acredite.se"
              required
            />
          </label>

          <label className="split2">
            Senha do email SMTP {!nWlpnId && <span className="required">*</span>}
            <Input
              onChange={(evtChange) => handlePartnerChange(evtChange)}
              value={oPartner.wlpn_csmtppassword || ''}
              type="password"
              name="wlpn_csmtppassword"
              required={!nWlpnId}
            />
          </label>

        </fieldset>

        {nWlpnId && (
          <LogoList
            nWlpnId={nWlpnId}
            cBaseLogoUrl={oPartner.cBaseLogoUrl}
            setAlert={props.setAlert}
            ref={oLogoListRef}
          />
        )}

        <div className="button-stack">
          <button
            type="button"
            className="btn alternate back btn btn-outline-secondary"
            title="Cancelar"
            onClick={() => history.push({ pathname: '/Partner' })}
          >
            {nWlpnId ? 'Cancelar' : 'Voltar'}
          </button>
          {nWlpnId ? (
            <button type="submit" value="salvar" className="btn btn btn-secondary" title="Salvar">
              Salvar
            </button>
          ) : (
            <button type="submit" value="salvar" className="btn btn btn-secondary" title="Criar">
              Criar
            </button>
          )}
        </div>

      </form>
    </>
  );
}

const PartnerFormWrapper = (props) => {
  const { nWlpnId } = props.match.params;
  return (
    <div className="centered">
      <div className="title-button">
        <h1>{nWlpnId ? 'Atualizar' : 'Cadastrar'} parceiro</h1>
      </div>
      <PartnerForm {...props} />
    </div>
  );
}

export default PartnerFormWrapper;